import Color = require("color-js");
import isEmpty from "lodash-es/isEmpty";
import { toast } from "react-toastify";
import * as Redux from "redux";
import { Dispatch } from "redux";
import { User as AuthUser } from "oidc-client-ts"
const Peaks = require("../../../../../Scripts/Vitalograph.WebPortal.Scripts.Peaks/dist/peaks");
import {
    OverreadStatusEnum,
    SessionNote,
    QueryOrderDirection,
    OverreadFixedCommentSet,
    OverreadFixedComment,
    CoughAnalysisSet as CAS,
    CoughAnalysisSetEvent,
    Query,
    CoughAnalysisSetsFixedCommentsDisplay,
    CoughAnalysisSetComment,
    Permission,
    CoughEventTypeEnum,
    QueryCondition,
    OverreadStatusIdEnum
} from "../../misc/api/apiTypes";
import * as TimerActions from "../../misc/middleware/TimerMiddleware";
import { isPeaksPoint } from "./eventMapping";
import {
    AnalyseState,
    SessionMetadata,
    WaveformType,
    HourBasedSegmentViewModel,
    ToWaveformNumeric,
    EditModeEnum
} from "./interfaces/state";
import {
    PeaksJs,
    PeaksJsEventAggregationType,
    PeaksPeriod,
    PeaksPoint,
    PeaksClick
} from "./interfacesPeaks/PeaksJS";
import { AnalysisMode } from "./store";
import { FixedCommentEntityTypeEnum } from "../../misc/api/FixedComments/FixedCommentSetEntityTypes";
import { StudyFixedCommentSet, FixedComment, CoughAnalysisSet, WebPortalClient, StudyCoughEventType } from "webportalclient";
import { CoughMarshalClient, RecordingPositionFilesData } from "@vitalograph/coughmarshalclient";
import { WebPortalLegacyClientInternal, WebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { GetHourSegments, MapPoint, WaveformPlayheadPositionConversionType } from "./MappingPositionHelper";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { CoughAnalysisSetTypeEnum } from "../../misc/api/CoughAnalysisSetTypes";
import { AuditTrailActionEnum } from "../../misc/api/ApiAuditActions";

declare const rootUrl: string;
declare const coughMarshalRootUrl: string;

export enum ActionType {
    InitializePeaks = "InitalizePeaks",
    InitializePeaksEvents = "InitalizePeaksEvents",
    RequestSessionMetadata = "RequestSessionMetadata",
    ReceiveSessionMetadata = "ReceiveSessionMetadata",
    SetStudyId = "SetStudyId",
    RequestNotes = "RequestNotes",
    ReceiveNotes = "ReceiveNotes",
    RequestAnalysisSetComments = "RequestAnalysisSetComments",
    RequestCurrentAnalysisSet = "RequestCurrentAnalysisSet",
    RequestVisualReviewForAnalysisSet = "RequestVisualReviewForAnalysisSet",
    ReceiveAnalysisSetComments = "ReceiveAnalysisSetComments",
    RemoveComment = "RemoveComment",
    AddComment = 'AddAnalysisSetComment',
    RequestBlindComments = "RequestBlindComments",
    DestoryPeaks = "DestoryPeaks",
    RequestEventTypes = "RequestEventTypes",
    ReceiveEventTypes = "ReceiveEventTypes",
    RequestEvents = "RequestEvents",
    LoadPositions = "LoadPositions",
    LoadingPositions = "LoadingPositions",
    ReceiveEvents = "ReceiveEvents",
    RequestCoughAnalysisSets = "RequestCoughAnalysisSets",
    ReceiveCoughAnalysisSets = "ReceiveCoughAnalysisSets",
    Play = "Play",
    Pause = "Pause",
    Reset = "Reset",
    ToggleMuteMicrophone = "ToggleMuteMicrophone",
    ToggleMuteSensor = "ToggleMuteSensor",
    ToggleGridline = "ToggleGridline",
    ToggleScrollAction = "ToggleScroll",
    SetZoomLevel = "SetZoomLevel",
    SkipForward = "SkipForward",
    SkipBackward = "SkipBackward",
    SetWaveform = "SetWaveform",
    ChangeWaveform = "ChangeWaveform",
    ChangeSelectedSegment = "ChangeSelectedSegment",
    ChangeSelectedEvent = "ChangeSelectedEvent",
    AddEvent = "AddEvent",
    MovePointEvent = "MovePointEvent",
    MovePeriodEvent = "MovePeriodEvent",
    FinishMovePointEvent = "FinishMovePointEvent",
    FinishMovePeriodEvent = "FinishMovePeriodEvent",
    RemovePointEvent = "RemovePointEvent",
    RemovePeriodEvent = "RemovePeriodEvent",
    EnterEditMode = "EnterEditMode",
    LoadError = "LoadError",
    HourlySegmentsLoadError = "HourlySegmentsLoadError",
    OpenFixedCommentsDialog = "OpenFixedCommentsDialog",
    CloseFixedCommentsDialog = "CloseFixedCommentsDialog",
    ToggleFixedComment = "ToggleFixedComment",
    OpenAnalysisSetDialog = "OpenAnalysisSetDialog",
    CloseAnalysisSetDialog = "CloseAnalysisSetDialog",
    OpenEventListDialog = "OpenEventListDialog",
    CloseEventListDialog = "CloseEventListDialog",
    OpenDisputedListDialog = "OpenDisputedListDialog",
    CloseDisputedListDialog = "CloseDisputedListDialog",
    CloseSendForVisualReviewDialog = "CloseSendForVisualReviewDialogAction",
    ToggleAnalysisSet = "ToggleAnalysisSet",
    ToggleKeyboardShortcuts = "ToggleKeyboardShortcuts",
    RequestFixedComments = "RequestFixedComments",
    ReceiveFixedComments = "ReceiveFixedComments",
    RequestWaveforms = "RequestWaveforms",
    ReceiveWaveforms = "ReceiveWaveforms",
    IsSegmented = "IsSegmented",
    SavePlaybackPosition = "SavePlaybackPosition",
    ResumePlaybackJump = "ResumePlaybackJump",
    ResumePlaybackJumpComplete = "ResumePlaybackJumpComplete",
    UpdateViewOnlyState = "UpdateViewOnlyState",
    UpdateAddEventByDoubleClickState = "UpdateAddEventByDoubleClickState",
    ClosePeaksEditMode = "ClosePeaksEditMode",
    ToggleSessionNotesVisibility = "ToggleSessionNotesVisibility",
    AddingNewNote = "AddingNewNote",
    AddNewNoteDone = "AddNewNoteDone",
    JumpToTimepoint = "JumpToTimepoint",
    JumpToTimepointComplete = "JumpToTimepointComplete",
    PeaksLoaded = "PeaksLoaded",
    ShowMaximumAnalysisSetsAlert = "ShowMaximumAnalysisSetsAlert",
    HideMaximumAnalysisSetsAlert = "HideMaximumAnalysisSetsAlert",
    PlayheadMapped = "PlayheadMapped",
    OpenHourSegmentsModal = "OpenHourSegmentsModal",
    CloseHourSegmentsModal = "CloseHourSegmentsModal",
    LoadHourSegments = "LoadHourSegments",
    RequestHourSegments = "RequestHourSegments",
    DeselectEditingEvents = "DeselectEditingEvents",
    ShowAcceptabilityAuditModal = "ShowAcceptabilityAuditModal",
    CloseAcceptabilityAuditModal = "CloseAcceptabilityAuditModal",
    AcceptabilitySetIsSubmitting = "AcceptabilitySetIsSubmitting",
    PopulateRawTimepoints = "PopulateRawTimepoints",
    PlaybackServiceStatusAction = "PlaybackServiceStatusAction",
    EventTypesNotConfigured = "EventTypesNotConfigured",
    SetEventDuplicateThreshold = "SetEventDuplicateThreshold",
    SetAcceptanceError = "SetAcceptanceError",
    SetDuplicateVerified = "SetDuplicateVerified",
    SetPointUpdated = "SetPointUpdated",
    SetDisputedAcceptanceError = "SetDisputedAcceptanceError",
    Loaded = "Loaded",
    SetVisualInspectionErrorAction = "SetVisualInspectionErrorAction",
    JumpToEnd = "JumpToEnd",
    SetAudioLength = "SetAudioLength",
    OTHER_ACTION = "_OTHER_ACTION_",
    SetCoughSettings = "SetCoughSettings",
    PointOrPeriodAdded = "PointOrPeriodAdded",
    PointOrPeriodRemoved = "PointOrPeriodRemoved",
    UpdateAnalysisSetEventLocally = "UpdateAnalysisSetEventLocally",
    ToggleQCStatements = "ToggleQCStatements"
}

export interface OtherAction {
    type: ActionType.OTHER_ACTION;
}

export type Action =
    | RequestSessionMetadataAction
    | ReceiveSessionMetadataAction
    | SetStudyIdAction
    | RequestNotesAction
    | ReceiveNotesAction
    | RequestVisualReviewForAnalysisSetAction
    | RequestAnalysisSetCommentAction
    | RequestCurrentAnalysisSetAction
    | RequestBlindCommentsAction
    | RemoveCommentAction
    | InitalizePeaksAction
    | DestoryPeaksAction
    | RequestEventsAction
    | LoadPositionsAction
    | LoadingPositionsAction
    | ReceiveEventsAction
    | RequestEventTypesAction
    | ReceiveEventTypesAction
    | PlayAction
    | PauseAction
    | ResetAction
    | IsSegmentedAction
    | ToggleMuteMicrophoneAction
    | ToggleMuteSensorAction
    | ToggleGridlineAction
    | ToggleScrollAction
    | SetZoomLevelAction
    | SkipBackwardAction
    | SkipForwardAction
    | ChangeWaveformAction
    | ChangeSelectedSegmentAction
    | SetWaveformAction
    | ChangeSelectedEventAction
    | AddEventAction
    | MovePointEventAction
    | ToggleSessionNotesVisibilityAction
    | MovePeriodEventAction
    | FinishMovePointEventAction
    | FinishMovePeriodEventAction
    | RemovePointEventAction
    | RemovePeriodEventAction
    | EnterEditModeAction
    | LoadErrorAction
    | HourlySegmentsLoadErrorAction
    | OpenFixedCommentsDialogAction
    | CloseFixedCommentsDialogAction
    | ToggleFixedCommentAction
    | RequestCoughAnalysisSetAction
    | ReceiveCoughAnalysisSetAction
    | OpenAnalysisSetDialogAction
    | CloseAnalysisSetDialogAsyncAction
    | ToggleAnalysisSetAction
    | OpenEventListDialogAction
    | OpenDisputedListDialogAction
    | CloseDisputedListDialogAction
    | CloseEventListDialogAction
    | CloseSendForVisualReviewDialogAction
    | ToggleKeyboardShortcutsAction
    | RequestFixedCommentsAction
    | ReceiveFixedCommentsAction
    | ResumePlaybackJumpAction
    | ResumePlaybackJumpCompleteAction
    | OtherAction
    | UpdateViewOnlyStateAction
    | UpdateAddEventByDoubleClickStateAction
    | InitalizePeaksEventsAction
    | SavePlaybackPositionAction
    | ClosePeaksEditModeAction
    | AddingNewNoteAction
    | AddNewNoteDoneAction
    | JumpToTimePointAction
    | ShowMaximumAnalysisSetsAlertAction
    | HideMaximumAnalysisSetsAlertAction
    | PlayheadMappedAction
    | OpenHourSegmentsModalAction
    | CloseHourSegmentsModalAction
    | LoadHourSegmentsAction
    | RequestHourSegmentsAction
    | DeselectEditingEventsAction
    | ShowAcceptabilityAuditModalAction
    | CloseAcceptabilityAuditModalAction
    | AcceptabilitySetIsSubmittingAction
    | PopulateRawTimepointsAction
    | PlaybackServiceStatusAction
    | EventTypesNotConfiguredAction
    | SetEventDuplicateThresholdAction
    | SetAcceptanceErrorAction
    | SetDuplicateVerifiedAction
    | SetPointUpdatedAction
    | SetDisputedAcceptanceErrorAction
    | LoadedAction
    | SetVisualInspectionErrorAction
    | UpdateAnalysisSetEventLocallyAction
    | JumpToEndAction
    | SetAudioLengthAction
    | SetCoughSettings
    | PointOrPeriodAddedEvent
    | PointOrPeriodRemovedEvent
    | ToggleQCStatementsAction;

const _hourSegments96hoursRaw = new Map([
    [
        WaveformType.CWFT_RAW.toString(),
        Array.from({ length: 96 }, (_, i) => {
            const startTime = i * 3600;
            const endTime = startTime + 3600;
            const rawHour = i.toString().padStart(2, "0");

            return new HourBasedSegmentViewModel({
                processedStartTime: startTime,
                processedEndTime: endTime,
                rawHour: rawHour,
            });
        }),
    ],
]);

export class PointOrPeriodAddedEvent implements Redux.Action {
    static create(addedItem: PeaksPoint | PeaksPeriod): PointOrPeriodAddedEvent {
        return {
            type: ActionType.PointOrPeriodAdded,
            eventData: addedItem
        };
    }
    type: ActionType.PointOrPeriodAdded;
    eventData: PeaksPoint | PeaksPeriod;
}


export class SetCoughSettings implements Redux.Action {
    static create(settings: boolean): SetCoughSettings {
        return {
            type: ActionType.SetCoughSettings,
            payload: settings,
        };
    }

    type: ActionType.SetCoughSettings;
    payload: boolean;
}

export class PointOrPeriodRemovedEvent implements Redux.Action {
    static create(isPoint: boolean, id?: string): PointOrPeriodRemovedEvent {
        return {
            type: ActionType.PointOrPeriodRemoved,
            isPoint: isPoint,
            id: id
        };
    }
    type: ActionType.PointOrPeriodRemoved;
    isPoint: boolean;
    id?: string;
}

export class RequestSessionMetadataAction implements Redux.Action {
    static create(): RequestSessionMetadataAction {
        return {
            type: ActionType.RequestSessionMetadata
        };
    }
    type: ActionType.RequestSessionMetadata;
}

export class ClosePeaksEditModeAction implements Redux.Action {
    static create(): ClosePeaksEditModeAction {
        return {
            type: ActionType.ClosePeaksEditMode
        };
    }
    type: ActionType.ClosePeaksEditMode;
}

export class ReceiveSessionMetadataAction implements Redux.Action {
    static create(metadata: SessionMetadata): ReceiveSessionMetadataAction {
        return {
            type: ActionType.ReceiveSessionMetadata,
            metadata
        };
    }
    type: ActionType.ReceiveSessionMetadata;
    metadata: SessionMetadata;
}

/**
 * Action to update the view only state of the analysis app.
 *
 * This is used when users select more than one analysis set.
 */
export class UpdateViewOnlyStateAction implements Redux.Action {
    static create(isViewOnly: boolean): UpdateViewOnlyStateAction {
        return {
            type: ActionType.UpdateViewOnlyState,
            isViewOnly
        };
    }
    type: ActionType.UpdateViewOnlyState;
    isViewOnly: boolean;
}

export class UpdateAddEventByDoubleClickStateAction implements Redux.Action {
    static create(canAddEventByDoubleClick: boolean): UpdateAddEventByDoubleClickStateAction {
        return {
            type: ActionType.UpdateAddEventByDoubleClickState,
            canAddEventByDoubleClick
        };
    }
    type: ActionType.UpdateAddEventByDoubleClickState;
    canAddEventByDoubleClick: boolean;
}

export class SetStudyIdAction implements Redux.Action {
    static create(studyId: string): SetStudyIdAction {
        return {
            type: ActionType.SetStudyId,
            studyId
        };
    }
    type: ActionType.SetStudyId;
    studyId: string;
}

export class InitializeSessionMetadataAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal, client: WebPortalApiClient, primaryAnalystSetId, coughMarshalClient: CoughMarshalClient) {
        return async (dispatch: Dispatch<AnalyseState>, getState: () => AnalyseState) => {
            dispatch(RequestSessionMetadataAction.create());

            let set: CAS = null;
            try {
                set = await legacyClient.getCoughAnalysisSet(primaryAnalystSetId);

                if (set === null) {
                    return dispatch(LoadErrorAction.create());
                }
            }
            catch (err) {
                return dispatch(LoadErrorAction.create());
            }

            await this.checkFirstTimeOpen(set, getState().core.isViewOnly, legacyClient);

            //The selected waveform for an analysis set can be set to null as it is only set when a QC is finished
            //Therefore, we default to the raw waveform type on the client side.
            if (set.TypeId !== CoughAnalysisSetTypeEnum.AbacasCoughCount) {
                dispatch(SetWaveformAction.create(set.Session.PrimaryWaveformType || WaveformType.CWFT_RAW));
            } else {
                dispatch(SetWaveformAction.create(WaveformType.CWFT_RAW));
            }
            dispatch(SetStudyIdAction.create(set.Study.Id));
            dispatch(InitializeSessionCommentsAsyncAction.create(client, set.Study.Id));
            dispatch(
                ReceiveSessionMetadataAction.create({
                    study: set.Study.Name,
                    siteNumber: set.Site.SiteNumber,
                    subjectNumber: set.Subject.SubjectNumber,
                    technician: set.Session.UploadTechnician,
                    visitName: set.Visit.Name,
                    sessionId: set.SessionId,
                    sessionName: set.Session.Name,
                    rawDuration: set.Session.RawDuration,
                    processedDuration: set.Session.ProcessedDuration,
                    sensorProcessedDuration: set.Session.SensorProcessedDuration,
                    adjudicationSourceSetId: set.AdjudicationSourceSetId,
                    adjudicationTargetSetId: set.AdjudicationTargetSetId
                })
            );
            dispatch(InitializeNotesAsyncAction.create(legacyClient));

            const coughSettings = await legacyClient.getStudyCoughSettings(set.Study.Id);
            dispatch(SetEventDuplicateThresholdAction.create(coughSettings.EventDuplicateThreshold));

            try {
                dispatch(LoadingPositionsAction.create());
                let positions;
                if (set.Session.RawDuration <= 86400) {
                    positions = await coughMarshalClient.getMappingData(set.SessionId);
                } else {
                    positions = await coughMarshalClient.getMappingDataBySplit(set.SessionId, getState().core.selectedSegment);
                }
                dispatch(LoadPositionsAction.create(positions));
            } catch (ex) {
                return dispatch(LoadErrorAction.create());
            }
        };
    }

    static async checkFirstTimeOpen(set, isViewOnly: boolean, legacyClient: WebPortalLegacyClientInternal) {
        const promises: Array<Promise<any>> = [];

        if (!isViewOnly) {
            if (isEmpty(set.Analyst)) {
                promises.push(legacyClient.updateAssignedAnalyst(set.Id));
            }

            if (!set.StartedDateTime) {
                promises.push(legacyClient.updateAnalysisStartDate(set.Id));
            }
        }

        return Promise.resolve(promises);
    }
}

export class InitializeNotesAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal) {
        return async (dispatch, getState: () => AnalyseState) => {

            const sessionId = getState().core.sessionMetadata.sessionId;

            dispatch(RequestNotesAction.create());
            const notesQuery = await legacyClient.getCoughSessionNotes(sessionId, {
                Filters: [
                ],
                Order: {
                    Member: "CreatedDate",
                    Direction: QueryOrderDirection.Ascending,
                }
            });

            dispatch(ReceiveNotesAction.create(notesQuery.Data));
        };
    }
}

export class RequestNotesAction implements Redux.Action {
    static create(): RequestNotesAction {
        return {
            type: ActionType.RequestNotes
        };
    }
    type: ActionType.RequestNotes;
}

export class ReceiveNotesAction implements Redux.Action {
    static create(notes: SessionNote[]): ReceiveNotesAction {
        return {
            type: ActionType.ReceiveNotes,
            notes
        };
    }
    type: ActionType.ReceiveNotes;
    notes: SessionNote[];
}

export class InitalizePeaksAction implements Redux.Action {
    static create(peaksJs: PeaksJs): InitalizePeaksAction {
        return {
            type: ActionType.InitializePeaks,
            peaksJs
        };
    }
    type: ActionType.InitializePeaks;
    peaksJs: PeaksJs;
}

export class InitalizePeaksEventsAction implements Redux.Action {
    static create(filteredPoints: PeaksPoint[], filteredPeriods: PeaksPeriod[]): InitalizePeaksEventsAction {
        return {
            type: ActionType.InitializePeaksEvents,
            points: filteredPoints,
            periods: filteredPeriods
        };
    }
    type: ActionType.InitializePeaksEvents;
    points: PeaksPoint[];
    periods: PeaksPeriod[];
}

export class DestoryPeaksAction implements Redux.Action {
    static create(): DestoryPeaksAction {
        return {
            type: ActionType.DestoryPeaks
        };
    }
    type: ActionType.DestoryPeaks;
}

export function MapPlayheadTimestamp(client: CoughMarshalClient, sessionId: string, previousPlayheadTimestamp: number, conversionType: number): Promise<number> {

    return client.mapPlayheadTo(sessionId, previousPlayheadTimestamp, conversionType)
        .then(result => result.mappedTimepoint);
}

export class InitalizePeaksAsyncAction {
    static create(
        coughMarshalClient: CoughMarshalClient,
        legacyClient: WebPortalLegacyClientInternal,
        client: WebPortalClient,
        user: AuthUser,
        sessionId: string,
        primaryAnalystSetId: string,
        newWaveform: string,
        previousPlaybackTimepoint: number,
        selectedSegment: number,
        skipMapping: boolean
    ) {
        return (dispatch, getState) => {
            return dispatch(
                InitializeCoughAnalysisSetsAsyncAction.create(legacyClient, sessionId, primaryAnalystSetId)
            ).then(async () => {
                const state = getState() as AnalyseState;

                const segmentHoursValue = selectedSegment * 24
                const segmentSecsStartTime = (segmentHoursValue - 24) * 60 * 60;

                let multiDayOffset = segmentSecsStartTime;
                let newplayhead = 0;
                try {

                    if (!skipMapping && state.core.previouslySelectedWaveform && newWaveform != state.core.previouslySelectedWaveform && previousPlaybackTimepoint) {
                        newplayhead = MapPoint(state.core.positions, InitalizePeaksAsyncAction.GetWaveformMappingConversionType(
                            WaveformType[state.core.previouslySelectedWaveform],
                            WaveformType[newWaveform]
                        ), previousPlaybackTimepoint + multiDayOffset,
                            state.core.selectedSegment);
                        newplayhead = newplayhead - multiDayOffset;
                    } else if (previousPlaybackTimepoint) {
                        newplayhead = previousPlaybackTimepoint + multiDayOffset;
                    }


                } catch (err) {
                    console.error(
                        "Could not fetch a mapped playhead timepoint from the Cough recording playback service! Setting playhead to 00:00:00.00",
                        err
                    );
                }



                if (state.core.peaksJs) {
                    dispatch(DestoryPeaksAction.create());
                }


                dispatch(InitializeEventTypesAsyncAction.create(state.core.studyId, client)).then(() => {
                    // TODO: This is brittle sometimes the reducer does not update the state quick
                    // enough before we try to use it
                    const postEventTypesState = getState() as AnalyseState;

                    let selectedSetIds = postEventTypesState.analysisSet.coughAnalysisSets
                        .filter(x => x.IsSelected)
                        .map(m => m.Id);

                    selectedSetIds =
                        selectedSetIds.length === 0 ? [primaryAnalystSetId] : selectedSetIds;

                    // The state should have the most up-to-date version of the isViewOnly tag.
                    // The variable passed in the create call could be stale.
                    const postEventTypesIsViewOnly = postEventTypesState.core.isViewOnly;

                    dispatch(
                        InitializeEventsAsyncAction.create(
                            legacyClient,
                            primaryAnalystSetId,
                            postEventTypesState.core.isViewOnly,
                            selectedSetIds,
                            newWaveform
                        )
                    ).then(async events => {
                        try {
                            if (coughMarshalRootUrl !== '') {
                                await fetch(`${coughMarshalRootUrl}/health/ready`)
                                    .then(response => response.json())
                                    .then(json => {
                                        if (json.status !== "Healthy") {
                                            return Promise.reject("The Cough recording playback service is unavailable at this time please try again later")
                                        }
                                    })
                                    .catch(() => {
                                        return Promise.reject("The Cough recording playback service is unavailable at this time please try again later");
                                    });
                            }
                        } catch (response) {
                            return dispatch(PlaybackServiceStatusAction.create(response));
                        }

                        const waveform = ToWaveformNumeric(newWaveform as WaveformType);
                        const playbackRoot: string = `${coughMarshalRootUrl}/api/v1/playback/`;
                        let audioStreamUrl = `${playbackRoot}recording/${sessionId}/${waveform}`;

                        const recording = await coughMarshalClient.getRecording(sessionId, "splits");
                        const segments = recording.splits.length;
                        if (segments > 1) {
                            audioStreamUrl = `${playbackRoot}recording/${sessionId}/${waveform}/${selectedSegment}`;
                        }

                        const audio = new Audio(audioStreamUrl);
                        audio.crossOrigin = "anonymous";
                        audio.preload = "metadata";

                        audio.onloadedmetadata = () => {
                            dispatch(SetAudioLengthAction.create(audio.duration));
                        }

                        const segmentSecsEndTime = segmentSecsStartTime === 0 ? 86400 : segmentSecsStartTime + 86400;
                        const filteredPointEvents = events?.points?.filter(x => x.rawTimestamp >= segmentSecsStartTime && x.rawTimestamp < segmentSecsEndTime);
                        const filteredPeriodEvents = events?.periods?.filter(x => x.rawStartTime >= segmentSecsStartTime && x.rawEndTime < segmentSecsEndTime);

                        const peaksJs = (Peaks as any).init({
                            container: document.getElementById("WaveformWrapper"),
                            template: document.getElementById("WaveformTemplate"),
                            dataUriDefaultFormat: "arraybuffer",
                            mediaElement: audio,
                            initialTime: newplayhead,
                            multiDayOffset: multiDayOffset,
                            initialZoomLevel: postEventTypesState.core.zoomLevel,
                            zoomAdapter: "static",
                            zoomLevels: [8, 12, 16, 32, 64, 128, 256, 512, 1024, 2048, 4096],
                            zoomWaveformColor: "#0088c7",
                            overviewWaveformColor: "#0088c7",
                            axisLabelColor: "black",
                            axisGridlineColor: "black",
                            intermediateMajorGridlineColor: "rgba(100,100,100,0.8)",
                            intermediateMinorGridlineColor: "rgba(170,170,170,0.8)",
                            intermediateSize: 0.1,
                            randomizeSegmentColor: true,
                            timeElement: document.getElementById("CurrentPosition"),
                            offsetElement: document.getElementById("CurrentOffset"),
                            points: filteredPointEvents,
                            segments: filteredPeriodEvents,
                            dblClickHandler: !postEventTypesIsViewOnly
                                ? peaksClickObj => {
                                    const dblClickHandlerState = getState() as AnalyseState;
                                    // If there is a point that is in edit mode, then double
                                    // clicking should not add an event.
                                    if (!dblClickHandlerState.core.peaksJs.inEditMode() && dblClickHandlerState.core.canAddEventByDoubleClick) {
                                        return AddPointEventAsyncAction.create(
                                            peaksJs,
                                            { currentPosition: peaksClickObj.currentPosition + (peaksClickObj.source === "zoom" ? multiDayOffset : 0) },
                                            sessionId,
                                            dispatch,
                                            dblClickHandlerState.core.selectedWaveform,
                                            coughMarshalClient,
                                            legacyClient
                                        );
                                    }
                                }
                                : null,
                            segmentClickHandler: !postEventTypesIsViewOnly
                                ? event => this.editModeClickHandler(getState, dispatch, event, coughMarshalClient, legacyClient)
                                : null,
                            pointClickHandler: !postEventTypesIsViewOnly
                                ? event => this.editModeClickHandler(getState, dispatch, event, coughMarshalClient, legacyClient)
                                : null
                        });

                        // NOTE: timebased looking, the handler below triggers
                        // after finishing dispatches below this event registration
                        peaksJs.on(
                            "peaks.ready",
                            InitalizePeaksAsyncAction.HandleWaveformReady(
                                peaksJs,
                                dispatch,
                                events,
                                WaveformType[newWaveform],
                                selectedSegment
                            )
                        );

                        peaksJs.on(
                            "error",
                            (err) => {
                                dispatch(LoadErrorAction.create());
                                throw new Error(err);
                            }
                        );

                        dispatch(
                            ChangeSelectedEventAction.create(
                                postEventTypesState.core.selectedEventType
                            )
                        );

                        return dispatch(InitalizePeaksAction.create(peaksJs));
                    });
                });
            }) as Promise<void>;
        };
    }

    private static GetWaveformMappingConversionType(
        pw: WaveformType,
        nw: WaveformType
    ): WaveformPlayheadPositionConversionType {
        const mapping: Record<
            string,
            WaveformPlayheadPositionConversionType
        > = {
            [`${WaveformType.CWFT_RAW}_${WaveformType.CWFT_PROCESSED}`]:
                WaveformPlayheadPositionConversionType.RawToProcessed,
            [`${WaveformType.CWFT_RAW}_${WaveformType.CWFT_SENSOR_PROCESSED}`]:
                WaveformPlayheadPositionConversionType.RawToSensorProcessed,
            [`${WaveformType.CWFT_RAW}_${WaveformType.CWFT_VTA_CT1}`]:
                WaveformPlayheadPositionConversionType.RawToVtaCt1,
            [`${WaveformType.CWFT_PROCESSED}_${WaveformType.CWFT_RAW}`]:
                WaveformPlayheadPositionConversionType.ProcessedToRaw,
            [`${WaveformType.CWFT_PROCESSED}_${WaveformType.CWFT_SENSOR_PROCESSED}`]:
                WaveformPlayheadPositionConversionType.ProcessedToSensorProcessed,
            [`${WaveformType.CWFT_PROCESSED}_${WaveformType.CWFT_VTA_CT1}`]:
                WaveformPlayheadPositionConversionType.ProcessedToVtaCt1,
            [`${WaveformType.CWFT_SENSOR_PROCESSED}_${WaveformType.CWFT_RAW}`]:
                WaveformPlayheadPositionConversionType.SensorProcessedToRaw,
            [`${WaveformType.CWFT_SENSOR_PROCESSED}_${WaveformType.CWFT_PROCESSED}`]:
                WaveformPlayheadPositionConversionType.SensorProcessedToProcessed,
            [`${WaveformType.CWFT_SENSOR_PROCESSED}_${WaveformType.CWFT_VTA_CT1}`]:
                WaveformPlayheadPositionConversionType.SensorProcessedToVtaCt1,
            [`${WaveformType.CWFT_VTA_CT1}_${WaveformType.CWFT_RAW}`]:
                WaveformPlayheadPositionConversionType.VtaCt1ToRaw,
            [`${WaveformType.CWFT_VTA_CT1}_${WaveformType.CWFT_PROCESSED}`]:
                WaveformPlayheadPositionConversionType.VtaCt1ToProcessed,
            [`${WaveformType.CWFT_VTA_CT1}_${WaveformType.CWFT_SENSOR_PROCESSED}`]:
                WaveformPlayheadPositionConversionType.VtaCt1ToSensorProcessed,
        };

        return (
            mapping[`${pw}_${nw}`] ??
            WaveformPlayheadPositionConversionType.NoChange
        );
    }

    private static editModeClickHandler(
        getState: () => AnalyseState,
        dispatch: Dispatch<AnalyseState>,
        event: PeaksPoint & PeaksPeriod,
        coughMarshalClient: CoughMarshalClient, legacyClient: WebPortalLegacyClientInternal
    ) {
        if (!event.editable) {
            return;
        }

        const state = getState();

        // If there is already a point/segment that is in edit mode,
        // Clicking on ANOTHER point/segment should not switch that point into edit mode.
        if (!state.core.peaksJs.inEditMode()) {
            return dispatch(MoveEventAsyncAction.create(event, coughMarshalClient, legacyClient));
        } else {
            toast.error(
                "Please ensure that all changes are confirmed with the confirm button or shortcut key."
            );
        }
    }

    private static HandleWaveformReady = (
        peaksJs: any,
        dispatch: any,
        events: any,
        currentWaveformType: WaveformType,
        segment: number
    ): any => async () => {
        if (currentWaveformType !== WaveformType.CWFT_RAW) {
            const segmentHoursValue = segment === 1 ? 0 : (segment * 24) - 24;
            dispatch(GetHourSegmentsAsyncAction.create(segmentHoursValue));
        } else {
            dispatch(LoadHourSegmentsAction.create(_hourSegments96hoursRaw));
        }

        dispatch(PopulateRawTimepointsAction.create(
            new Map(events.points.map((p: PeaksPoint) => [p.id, p.rawTimestamp] as [string, number]))
        ));

        dispatch(PlayheadMappedAction.create());

        dispatch(InitalizePeaksEventsAction.create(peaksJs.points.getPoints(), peaksJs.segments.getSegments()));
    };
}

export class RequestCoughAnalysisSetAction implements Redux.Action {
    static create(): RequestCoughAnalysisSetAction {
        return {
            type: ActionType.RequestCoughAnalysisSets
        };
    }
    type: ActionType.RequestCoughAnalysisSets;
}

export class ReceiveCoughAnalysisSetAction implements Redux.Action {
    static create(sets: CoughAnalysisSetsFixedCommentsDisplay[]): ReceiveCoughAnalysisSetAction {
        return {
            type: ActionType.ReceiveCoughAnalysisSets,
            sets
        };
    }
    type: ActionType.ReceiveCoughAnalysisSets;
    sets: CoughAnalysisSetsFixedCommentsDisplay[];
}

export class InitializeCoughAnalysisSetsAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal, sessionId: string, primaryAnalystSetId: string) {
        return dispatch => {
            dispatch(RequestCoughAnalysisSetAction.create());

            return legacyClient.getAnalysisSetFixedComments([
                {
                    Member: "SessionId",
                    Values: [sessionId]
                }
            ])
                .then(json => {
                    function sortByCurrentAndCreated(a, b) {
                        if (a.Id === primaryAnalystSetId) {
                            return -1;
                        }

                        if (b.Id === primaryAnalystSetId) {
                            return 1;
                        }

                        if (a.CreatedDateTime < b.CreatedDateTime) {
                            return -1;
                        } else if (a.CreatedDateTime > b.CreatedDateTime) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }

                    const sets = [...json.Data].sort(sortByCurrentAndCreated)
                        .map((cset, index) => {
                            return {
                                ...cset,
                                DisplayOrder: index,
                            };
                        });

                    dispatch(ReceiveCoughAnalysisSetAction.create(sets));
                });
        };
    }
}

export class RequestEventTypesAction implements Redux.Action {
    static create(): RequestEventTypesAction {
        return {
            type: ActionType.RequestEventTypes
        };
    }
    type: ActionType.RequestEventTypes;
}

export class ReceiveEventTypesAction implements Redux.Action {
    static create(eventTypes: Array<StudyCoughEventType>): ReceiveEventTypesAction {
        return {
            type: ActionType.ReceiveEventTypes,
            eventTypes
        };
    }
    type: ActionType.ReceiveEventTypes;
    eventTypes: Array<StudyCoughEventType>;
}

export class InitializeEventTypesAsyncAction {
    static create(studyId: string, client: WebPortalClient) {
        return async dispatch => {
            dispatch(RequestEventTypesAction.create());

            const eventTypes = await client.getStudyCoughEventTypes(undefined, `studyId eq ${studyId} and hidden eq false`, "order asc");

            if (eventTypes.value.length === 0)
                dispatch(EventTypesNotConfiguredAction.create());
            else
                dispatch(ReceiveEventTypesAction.create(eventTypes.value));
        };
    }
}

export class RequestEventsAction implements Redux.Action {
    static create(): RequestEventsAction {
        return {
            type: ActionType.RequestEvents
        };
    }
    type: ActionType.RequestEvents;
}
export class LoadPositionsAction implements Redux.Action {
    static create(positions: RecordingPositionFilesData): LoadPositionsAction {
        return {
            type: ActionType.LoadPositions,
            positions: positions
        };
    }
    type: ActionType.LoadPositions;
    positions: RecordingPositionFilesData;
}
export class LoadingPositionsAction implements Redux.Action {
    static create(): LoadingPositionsAction {
        return {
            type: ActionType.LoadingPositions,
        };
    }
    type: ActionType.LoadingPositions;
}


export class ReceiveEventsAction implements Redux.Action {
    static create(json): ReceiveEventsAction {
        return {
            type: ActionType.ReceiveEvents,
            json
        };
    }
    type: ActionType.ReceiveEvents;
    json: any;
}

export class GetPointsForFinalDecision {
    static create(
        legacyClient: WebPortalLegacyClientInternal) {

        return async (dispatch, getState) => {
                const state = getState() as AnalyseState;

                let selectedSetIds = state.analysisSet.coughAnalysisSets
                    .filter(x => x.IsSelected)
                    .map(m => m.Id);

                selectedSetIds =
                    selectedSetIds.length === 0 ? [state.analysisSet.primaryAnalystSetId] : selectedSetIds;

                const events = await legacyClient.getCoughAnalysisSetEvents({
                    Filters: [
                        {
                            Member: "AnalysisSetId",
                            Values: selectedSetIds
                        },
                        {
                            Member: "RawEnd", /* to get events which don't have end time set, i.e. point events */
                            Values: null
                        }
                    ]
                });

                let points = InitializeEventsAsyncAction.aggregateEvents(
                    events,
                    state,
                    state.analysisSet.primaryAnalystSetId,
                    WaveformType.CWFT_RAW,
                    PeaksJsEventAggregationType.Point
            );

            return points;

        };
    }
}

export class InitializeEventsAsyncAction {
    // TODO: Cannot rely on the parameters being sent to this function. It should use the fields
    // in the current state.
    static create(
        legacyClient: WebPortalLegacyClientInternal,
        primaryAnalystSetId: string,
        isViewOnly: boolean,
        selectedSetIds: string[],
        selectedWaveform: string
    ) {
        return async (dispatch, getState) => {
            dispatch(RequestEventsAction.create());



            try {
                const events = await legacyClient.getCoughAnalysisSetEvents({
                    Filters: [
                        {
                            Member: "AnalysisSetId",
                            Values: selectedSetIds
                        }
                    ]
                });

                const state = getState() as AnalyseState;

                const points = InitializeEventsAsyncAction.aggregateEvents(
                    events,
                    state,
                    primaryAnalystSetId,
                    selectedWaveform,
                    PeaksJsEventAggregationType.Point
                );

                const periods = InitializeEventsAsyncAction.aggregateEvents(
                    events,
                    state,
                    primaryAnalystSetId,
                    selectedWaveform,
                    PeaksJsEventAggregationType.Period
                );

                return { points, periods };
            }
            catch {
                dispatch(LoadErrorAction.create());
            }


        };
    }

    private static getEventType = (eventTypes: StudyCoughEventType[], e: any) =>
        eventTypes.find(x => x.id === e.EventTypeId);

    static aggregateEvents(
        json: Query<CoughAnalysisSetEvent>,
        state: AnalyseState,
        primaryAnalystSetId: string,
        selectedWaveform: string,
        aggregationType: PeaksJsEventAggregationType
    ): any[] {
        return json.Data.reduce((eventsProjected, e) => {
            const eventType = InitializeEventsAsyncAction.getEventType(
                state.core.availableEventTypes,
                e
            );
            const coughAnalysisSet = InitializeEventsAsyncAction.getCurrentCoughAnalysisSet(
                state,
                e
            );

            if (coughAnalysisSet.Type.Id === CoughAnalysisSetTypeEnum.Adjudication && e.Disputed !== undefined) {
                state.core.confirmedDuplicatePoints.add(e.Id)
            }

            const commonData = {
                id: e.Id,
                eventTypeId: eventType.id,
                eventTypeName: eventType.name,
                labelText: coughAnalysisSet.Type.Name,
                // The state should have the most up-to-date version of the isViewOnly property.
                editable: !state.core.isViewOnly && e.AnalysisSetId === primaryAnalystSetId,
                editMode: false,
                color: coughAnalysisSet.Type.Id === CoughAnalysisSetTypeEnum.Adjudication && coughAnalysisSet.StatusId !== OverreadStatusIdEnum.Accepted && eventType.period === false ?
                    e.Disputed && e.DisputedAccepted !== true ? InitializeEventsAsyncAction.getDisputedEventColour(eventType) :
                        InitializeEventsAsyncAction.getUndisputedEventColour(eventType) : e.AnalysisSetId === primaryAnalystSetId
                        ? InitializeEventsAsyncAction.getPrimarySetsEventColour(eventType)
                        : InitializeEventsAsyncAction.getSecondarySetsEventColour(eventType),
                layerPosition: coughAnalysisSet.DisplayOrder,
                withinDuplicateThreshold: e.WithinDuplicateThreshold,
                confirmedValidDuplicate: state.core.confirmedDuplicatePoints.has(e.Id),
                disputed: e.Disputed,
                disputedComment: e.DisputedComment,
                disputedAccepted: e.DisputedAccepted
            };

            if (eventType.period && aggregationType === PeaksJsEventAggregationType.Period) {
                let startTime, endTime;
                switch (selectedWaveform) {
                    case WaveformType.CWFT_RAW:
                        startTime = e.RawStart;
                        endTime = e.RawEnd;
                        break;
                    case WaveformType.CWFT_PROCESSED:
                        startTime = e.ProcessedStart ?? 0;
                        endTime = e.ProcessedEnd;
                        break;
                    case WaveformType.CWFT_VTA_CT1:
                        startTime = e.VtaCt1Start ?? 0;
                        endTime = e.VtaCt1End;
                        break;
                    case WaveformType.CWFT_SENSOR_PROCESSED:
                        startTime = e.SensorProcessedStart ?? 0;
                        endTime = e.SensorProcessedEnd;
                        break;
                }

                eventsProjected.push({
                    ...commonData,
                    startTime,
                    endTime,
                    rawStartTime: e.RawStart,
                    rawEndTime: e.RawEnd
                });
            } else if (
                !eventType.period &&
                aggregationType === PeaksJsEventAggregationType.Point
            ) {
                let timestamp;
                switch (selectedWaveform) {
                    case WaveformType.CWFT_RAW:
                        timestamp = e.RawStart;
                        break;
                    case WaveformType.CWFT_PROCESSED:
                        timestamp = e.ProcessedStart ?? 0;
                        break;
                    case WaveformType.CWFT_VTA_CT1:
                        timestamp = e.VtaCt1Start ?? 0;
                        break;
                    case WaveformType.CWFT_SENSOR_PROCESSED:
                        timestamp = e.SensorProcessedStart ?? 0;
                        break;
                }
                eventsProjected.push({
                    ...commonData,
                    timestamp,
                    rawTimestamp: e.RawStart
                });
            }

            if (aggregationType === PeaksJsEventAggregationType.Point) {
                for (const point of eventsProjected) {
                    point.withinDuplicateThreshold = false;
                }

                var rawTimestampPoints = new Map(eventsProjected.map((p: PeaksPoint) => [p.id, p.rawTimestamp] as [string, number]));

                const coughPeakEvent = state.core.availableEventTypes.find(x => x.refEventTypeId === CoughEventTypeEnum.CoughPeak);

                const valuesInThreshold = eventsProjected.filter(x => x.layerPosition === 0 && x.eventTypeId === coughPeakEvent.id)
                    .filter((ev1, _, entries) =>
                        entries.some((ev2) => ev1.id !== ev2.id && Math.abs((rawTimestampPoints.get(ev1.id) * 1000) - (rawTimestampPoints.get(ev2.id) * 1000)) <= state.core.eventDuplicateThreshold)
                    );

                const remainingUnconfirmed = valuesInThreshold.filter(x => !x.confirmedValidDuplicate);

                if (remainingUnconfirmed.length > 0) {
                    for (const point of remainingUnconfirmed) {
                        point.withinDuplicateThreshold = true;
                    }
                }
            }

            return eventsProjected;
        }, []);
    }

    private static getCurrentCoughAnalysisSet = (state: AnalyseState, e: any) =>
        state.analysisSet.coughAnalysisSets.find(i => i.Id === e.AnalysisSetId);

    private static getSecondarySetsEventColour = (eventType: StudyCoughEventType) =>
        Color(eventType.colour)
            .setAlpha(0.6)
            .lightenByRatio(0.75)
            .toCSS();

    private static getPrimarySetsEventColour = (eventType: StudyCoughEventType) =>
        Color(eventType.colour)
            .setAlpha(0.6)
            .toCSS();

    private static getDisputedEventColour = (eventType: StudyCoughEventType) =>
        Color(eventType.colour)
            .setAlpha(0.9)
            .toCSS();

    private static getUndisputedEventColour = (eventType: StudyCoughEventType) =>
        Color(eventType.colour)
            .setAlpha(0.6)
            .lightenByRatio(0.50)
            .toCSS();


}

export class PlayAsyncAction {
    static create() {
        return dispatch => {
            dispatch(PlayAction.create());
            dispatch(
                TimerActions.StartTimerAction.create(
                    "SavePlaybackPosition",
                    SavePlaybackPositionAction.create(),
                    5000
                )
            );
        };
    }
}

export class PlayAction implements Redux.Action {
    static create(): PlayAction {
        return {
            type: ActionType.Play
        };
    }
    type: ActionType.Play;
}

export class PauseAsyncAction {
    static create() {
        return dispatch => {
            dispatch(PauseAction.create());
            dispatch(SavePlaybackPositionAction.create());
            dispatch(TimerActions.StopTimerAction.create("SavePlaybackPosition"));
        };
    }
}

export class PauseAction implements Redux.Action {
    static create(): PauseAction {
        return {
            type: ActionType.Pause
        };
    }

    type: ActionType.Pause;
}

export class ResetAction implements Redux.Action {
    static create(): ResetAction {
        return {
            type: ActionType.Reset
        };
    }

    type: ActionType.Reset;
}

export class JumpToEndAction implements Redux.Action {
    static create(): JumpToEndAction {
        return {
            type: ActionType.JumpToEnd
        };
    }

    type: ActionType.JumpToEnd;
}
export class ToggleMuteMicrophoneAction implements Redux.Action {
    static create(): ToggleMuteMicrophoneAction {
        return {
            type: ActionType.ToggleMuteMicrophone
        };
    }
    type: ActionType.ToggleMuteMicrophone;
}

export class ToggleMuteSensorAction implements Redux.Action {
    static create(): ToggleMuteSensorAction {
        return {
            type: ActionType.ToggleMuteSensor
        };
    }
    type: ActionType.ToggleMuteSensor;
}

export class ToggleGridlineAction implements Redux.Action {
    static create(): ToggleGridlineAction {
        return {
            type: ActionType.ToggleGridline
        };
    }
    type: ActionType.ToggleGridline;
}

export class ToggleScrollAction implements Redux.Action {
    static create(): ToggleScrollAction {
        return {
            type: ActionType.ToggleScrollAction
        };
    }
    type: ActionType.ToggleScrollAction;
}

export class SetZoomLevelAction implements Redux.Action {
    static create(level: number): SetZoomLevelAction {
        if (level < 0) {
            level = 0;
        }

        if (level > 10) {
            level = 10;
        }

        return {
            type: ActionType.SetZoomLevel,
            level
        };
    }
    type: ActionType.SetZoomLevel;
    level: number;
}

export class SkipBackwardAction implements Redux.Action {
    static create(): SkipBackwardAction {
        return {
            type: ActionType.SkipBackward
        };
    }
    type: ActionType.SkipBackward;
}

export class SkipForwardAction implements Redux.Action {
    static create(): SkipForwardAction {
        return {
            type: ActionType.SkipForward
        };
    }
    type: ActionType.SkipForward;
}

export class SetWaveformAction implements Redux.Action {
    static create(waveform: string): SetWaveformAction {
        return {
            type: ActionType.SetWaveform,
            waveform
        };
    }

    type: ActionType.SetWaveform;
    waveform: string;
}

export class ChangeSelectedSegmentAction implements Redux.Action {
    static create(segment: number): ChangeSelectedSegmentAction {
        return {
            type: ActionType.ChangeSelectedSegment,
            segment
        };
    }

    type: ActionType.ChangeSelectedSegment;
    segment: number;
}

export class ChangeSelectedSegmentAsyncAction {
    static create(segment: number, coughMarshalClient: CoughMarshalClient, webPortalApiClient: WebPortalApiClient, sessionId: string, analysisSetId: string) {
        return async (dispatch, getState) => {
            dispatch(ChangeSelectedSegmentAction.create(segment));
            try {
                dispatch(LoadingPositionsAction.create());
                const positions = await coughMarshalClient.getMappingDataBySplit(sessionId, getState().core.selectedSegment);
                dispatch(LoadPositionsAction.create(positions));
                dispatch(SetVisualInspectionErrorAction.create(null));
                dispatch(InitializeAnalysisSetCommentAsyncAction.create(webPortalApiClient, analysisSetId, segment));
                dispatch(LoadedAction.create());
            } catch {
                return dispatch(LoadErrorAction.create());
            }
        }
    }
}

export class ChangeWaveformAction implements Redux.Action {
    static create(currentWaveform: string, waveformToChangeTo: string, currentTime: number, legacyClient: WebPortalLegacyClientInternal): ChangeWaveformAction {
        return {
            type: ActionType.ChangeWaveform,
            currentWaveform,
            waveformToChangeTo,
            currentTime,
            legacyClient,
        };
    }

    type: ActionType.ChangeWaveform;
    currentWaveform: string;
    waveformToChangeTo: string;
    currentTime: number;
    legacyClient: WebPortalLegacyClientInternal;
}

export class ChangeWaveformAsyncAction {
    static create(newlySelectedWaveform: string, legacyClient: WebPortalLegacyClientInternal) {
        return (dispatch, getState) => {
            const state = getState() as AnalyseState;
            
            if (state.core.isEditMode !== EditModeEnum.NotEditing) {
                toast.warning("Confirm the edited event before changing waveform");
                return;
            }

            dispatch(PauseAction.create());

            const abacasSet = state.analysisSet.coughAnalysisSets.find(a => a.Type.Id === CoughAnalysisSetTypeEnum.AbacasCoughCount);
            if (abacasSet !== undefined && abacasSet.IsSelected && (newlySelectedWaveform === WaveformType.CWFT_PROCESSED || newlySelectedWaveform === WaveformType.CWFT_SENSOR_PROCESSED)) {
                dispatch(ToggleAnalysisSetAction.create(abacasSet.Id, false));
                toast.warning(`Abacas Cough Count analysis set removed as only viewable in Raw waveform`);
            }

            dispatch(ChangeWaveformAction.create(state.core.selectedWaveform, newlySelectedWaveform, state.core.peaksJs.time.getCurrentTime(), legacyClient));
        };
    }
}

export class ChangeSelectedEventAction implements Redux.Action {
    static create(eventType: StudyCoughEventType): ChangeSelectedEventAction {
        return {
            type: ActionType.ChangeSelectedEvent,
            eventType
        };
    }
    type: ActionType.ChangeSelectedEvent;
    eventType: StudyCoughEventType;
}

export class AddPointEventAsyncAction {
    static create(peaksJs: PeaksJs, peaksObj: PeaksClick, sessionId, dispatch, selectedWaveform: string, coughMarshalClient: CoughMarshalClient, legacyClient: WebPortalLegacyClientInternal) {
        const pointEvent = {
            id: sessionId,
            editable: true,
            timestamp: peaksObj.currentPosition,
            rawTimestamp: selectedWaveform === "CWFT_RAW" ? peaksObj.currentPosition : 0,
            isPoint: true,
        } as PeaksPoint;

        return dispatch(AddEventAction.create(pointEvent, coughMarshalClient, legacyClient));
    }
}

export class AddPeriodEventAsyncAction {
    static create(peaksObj: PeaksClick, endTime: number, sessionId, dispatch, coughMarshalClient: CoughMarshalClient, legacyClient: WebPortalLegacyClientInternal) {
        const periodEvent = {
            id: sessionId,
            editable: true,
            startTime: peaksObj.currentPosition,
            endTime: endTime,
            layerPosition: 0,
            isPoint: false,
        };

        return dispatch(AddEventAction.create(periodEvent, coughMarshalClient, legacyClient));
    }
}

export class AddEventAction implements Redux.Action {
    static create(event, coughMarshalClient: CoughMarshalClient, legacyClient: WebPortalLegacyClientInternal): AddEventAction {
        return {
            type: ActionType.AddEvent,
            event,
            coughMarshalClient,
            legacyClient
        };
    }
    type: ActionType.AddEvent;
    event;
    coughMarshalClient: CoughMarshalClient;
    legacyClient: WebPortalLegacyClientInternal;
}

export class MoveEventAsyncAction {
    static create(peaksObj, coughMarshalClient: CoughMarshalClient, legacyClient: WebPortalLegacyClientInternal) {
        return (dispatch, getState) => {
            if (isPeaksPoint(peaksObj)) {
                if (peaksObj.editMode) {
                    return dispatch(FinishMovePointEventAction.create(coughMarshalClient, legacyClient));
                } else {
                    return dispatch(MovePointEventAction.create(peaksObj));
                }
            } else {
                if (peaksObj.editMode) {
                    return dispatch(FinishMovePeriodEventAsyncAction.create(coughMarshalClient, legacyClient));
                } else {
                    return dispatch(MovePeriodEventAction.create(peaksObj));
                }
            }
        }
    }
}

export class MovePointEventAction implements Redux.Action {
    static create(event: PeaksPoint): MovePointEventAction {
        return {
            type: ActionType.MovePointEvent,
            event
        };
    }
    type: ActionType.MovePointEvent;
    event: PeaksPoint;
}

export class MovePeriodEventAction implements Redux.Action {
    static create(event: PeaksPeriod): MovePeriodEventAction {
        return {
            type: ActionType.MovePeriodEvent,
            event
        };
    }
    type: ActionType.MovePeriodEvent;
    event: PeaksPeriod;
}

export class FinishMovePointEventAction implements Redux.Action {
    static create(coughMarshalClient: CoughMarshalClient, legacyClient: WebPortalLegacyClientInternal): FinishMovePointEventAction {
        return {
            type: ActionType.FinishMovePointEvent,
            coughMarshalClient,
            legacyClient
        };
    }
    type: ActionType.FinishMovePointEvent;
    coughMarshalClient: CoughMarshalClient;
    legacyClient: WebPortalLegacyClientInternal;
}

export class FinishMovePeriodEventAsyncAction {
    static create(coughMarshalClient: CoughMarshalClient, legacyClient: WebPortalLegacyClientInternal) {
        return (dispatch, getState) => {
            const state = getState();
            const period = state.core.peaksJs.waveform.activeSegment;

            if (period.startTime >= period.endTime) {
                toast.error(`Failed marking '${state.core.peaksJs.segments.getSegmentEventTypeLabel(period)}'. Start time cannot be after End time for period events.`);
                return;
            }

            dispatch(FinishMovePeriodEventAction.create(coughMarshalClient, legacyClient));
        }
    }
}

export class FinishMovePeriodEventAction implements Redux.Action {
    static create(coughMarshalClient: CoughMarshalClient, legacyClient: WebPortalLegacyClientInternal): FinishMovePeriodEventAction {
        return {
            type: ActionType.FinishMovePeriodEvent,
            coughMarshalClient,
            legacyClient,
        };
    }
    type: ActionType.FinishMovePeriodEvent;
    coughMarshalClient: CoughMarshalClient;
    legacyClient: WebPortalLegacyClientInternal;
}

export class DeselectEditingEventsAction implements Redux.Action {
    static create(): DeselectEditingEventsAction {
        return {
            type: ActionType.DeselectEditingEvents
        };
    }

    type: ActionType.DeselectEditingEvents;
}

export class RemovePointEventAction implements Redux.Action {
    static create(legacyClient: WebPortalLegacyClientInternal, id?: string): RemovePointEventAction {
        return {
            type: ActionType.RemovePointEvent,
            legacyClient,
            id,
        };
    }
    type: ActionType.RemovePointEvent;
    legacyClient: WebPortalLegacyClientInternal
    id?: string; // Optional, otherwise active will be removed,

}

export class RemovePeriodEventAction implements Redux.Action {
    static create(legacyClient: WebPortalLegacyClientInternal, id?: string): RemovePeriodEventAction {
        return {
            type: ActionType.RemovePeriodEvent,
            legacyClient,
            id
        };
    }
    type: ActionType.RemovePeriodEvent;
    legacyClient: WebPortalLegacyClientInternal;
    id?: string; // Optional, otherwise active will be removed
}

export class EnterEditModeAction implements Redux.Action {
    static create(): EnterEditModeAction {
        return {
            type: ActionType.EnterEditMode
        };
    }
    type: ActionType.EnterEditMode;
}

export class LoadErrorAction implements Redux.Action {
    static create(): LoadErrorAction {
        return {
            type: ActionType.LoadError
        };
    }
    type: ActionType.LoadError;
}

export class HourlySegmentsLoadErrorAction implements Redux.Action {
    static create(): HourlySegmentsLoadErrorAction {
        return {
            type: ActionType.HourlySegmentsLoadError
        };
    }
    type: ActionType.HourlySegmentsLoadError;
}

export class OpenFixedCommentsDialogAction implements Redux.Action {
    static create(): OpenFixedCommentsDialogAction {
        return {
            type: ActionType.OpenFixedCommentsDialog
        };
    }
    type: ActionType.OpenFixedCommentsDialog;
}

export class CloseFixedCommentsDialogAction implements Redux.Action {
    static create(): CloseFixedCommentsDialogAction {
        return {
            type: ActionType.CloseFixedCommentsDialog
        };
    }
    type: ActionType.CloseFixedCommentsDialog;
}

export class ToggleFixedCommentAction implements Redux.Action {
    /**
     *
     * Toggling the fixed comment for an analysis set. Fixed comments are not uniquely identifyable
     * by the commentId as the comment must have an associated analysis set. This is because
     * different analysis sets can have different sets of comments.
     *
     * @param commentId
     * @param checked
     * @param analysisSetId
     */
    static create(
        commentId: string,
        checked: boolean,
        analysisSetId: string
    ): ToggleFixedCommentAction {
        return {
            type: ActionType.ToggleFixedComment,
            commentId,
            checked,
            analysisSetId
        };
    }
    type: ActionType.ToggleFixedComment;
    commentId: string;
    checked: boolean;
    analysisSetId: string;
}

export class OpenAnalysisSetDialogAction implements Redux.Action {
    static create(): OpenAnalysisSetDialogAction {
        return {
            type: ActionType.OpenAnalysisSetDialog
        };
    }
    type: ActionType.OpenAnalysisSetDialog;
}

/**
 *
 * Closing the analysis dialog prompts a check on whether the analysis app should be
 * in view only mode or in edit mode.
 *
 */
export class CloseAnalysisSetDialogAsyncAction implements Redux.Action {
    static create(legacyClient: WebPortalLegacyClientInternal, coughMarshalClient: CoughMarshalClient, webPortalClient: WebPortalClient, user: AuthUser, userPermissions: Permission[]) {
        return (dispatch, getState) => {
            const state = getState() as AnalyseState;
            const currentTimepoint = state.core.peaksJs.time.getCurrentTime();
            const selectedSetsCount = state.analysisSet.coughAnalysisSets.filter(
                x => x.IsSelected === true
            ).length;

            if (selectedSetsCount > 5) {
                return dispatch(ShowMaximumAnalysisSetsAlertAction.create());
            }

            dispatch(HideMaximumAnalysisSetsAlertAction.create());

            // Closing the dialog
            dispatch(CloseAnalysisSetDialogAction.create());

            // The master mode should always overwrite the view only state
            if (state.core.mode === AnalysisMode.Readonly) {
                dispatch(UpdateViewOnlyStateAction.create(true));
            }

            if (!userPermissions.map(x => x.Id).includes(PermissionEnum.MarkEventsViewingManyAnalysisSets)) {
                const sets = state.analysisSet.coughAnalysisSets.filter(
                    set => set.Type.Id !== CoughAnalysisSetTypeEnum.QualityCheck && set.Type.Id !== CoughAnalysisSetTypeEnum.DeviceEvents
                );

                // Updating the viewonly status if more than one analysis set is selected.
                dispatch(
                    UpdateViewOnlyStateAction.create(sets.filter(set => set.IsSelected).length > 1)
                );
            }

            dispatch(
                InitalizePeaksAsyncAction.create(
                    coughMarshalClient,
                    legacyClient,
                    webPortalClient,
                    user,
                    state.core.sessionMetadata.sessionId,
                    state.analysisSet.primaryAnalystSetId,
                    state.core.selectedWaveform,
                    currentTimepoint,
                    state.core.selectedSegment,
                    true
                )
            );
        };
    }
    type: ActionType.CloseAnalysisSetDialog;
}

export class CloseAnalysisSetDialogAction implements Redux.Action {
    static create(): CloseAnalysisSetDialogAction {
        return {
            type: ActionType.CloseAnalysisSetDialog
        };
    }
    type: ActionType.CloseAnalysisSetDialog;
}

export class OpenDisputedListDialogAction implements Redux.Action {
    static create(): OpenDisputedListDialogAction {
        return {
            type: ActionType.OpenDisputedListDialog
        };
    }
    type: ActionType.OpenDisputedListDialog;
}

export class CloseDisputedListDialogAction implements Redux.Action {
    static create(): CloseDisputedListDialogAction {
        return {
            type: ActionType.CloseDisputedListDialog
        };
    }
    type: ActionType.CloseDisputedListDialog;
}

export class OpenEventListDialogAction implements Redux.Action {
    static create(): OpenEventListDialogAction {
        return {
            type: ActionType.OpenEventListDialog
        };
    }
    type: ActionType.OpenEventListDialog;
}

export class CloseEventListDialogAction implements Redux.Action {
    static create(): CloseEventListDialogAction {
        return {
            type: ActionType.CloseEventListDialog
        };
    }
    type: ActionType.CloseEventListDialog;
}

export class CloseSendForVisualReviewDialogAction implements Redux.Action {
    static create(): CloseSendForVisualReviewDialogAction {
        return {
            type: ActionType.CloseSendForVisualReviewDialog
        };
    }
    type: ActionType.CloseSendForVisualReviewDialog;
}

export class IsSegmentedAction implements Redux.Action {
    static create(isSegmented: boolean): IsSegmentedAction {
        return {
            type: ActionType.IsSegmented,
            isSegmented,
        };
    }
    type: ActionType.IsSegmented;
    isSegmented: boolean;

}

export class ToggleAnalysisSetAction implements Redux.Action {
    static create(setId: string, checked: boolean): ToggleAnalysisSetAction {
        return {
            type: ActionType.ToggleAnalysisSet,
            setId,
            checked
        };
    }
    type: ActionType.ToggleAnalysisSet;
    setId: string;
    checked: boolean;
}

export class ToggleKeyboardShortcutsAction implements Redux.Action {
    static create(): ToggleKeyboardShortcutsAction {
        return {
            type: ActionType.ToggleKeyboardShortcuts
        };
    }
    type: ActionType.ToggleKeyboardShortcuts;
}

export class RequestFixedCommentsAction implements Redux.Action {
    static create(): RequestFixedCommentsAction {
        return {
            type: ActionType.RequestFixedComments
        };
    }
    type: ActionType.RequestFixedComments;
}

export class ReceiveFixedCommentsAction implements Redux.Action {
    static create(comments: FixedComment[]): ReceiveFixedCommentsAction {
        return {
            type: ActionType.ReceiveFixedComments,
            comments
        };
    }
    type: ActionType.ReceiveFixedComments;
    comments: FixedComment[];
}

export class InitializeSessionCommentsAsyncAction {
    static create(client: WebPortalApiClient, studyId: string) {
        return dispatch => {
            dispatch(RequestFixedCommentsAction.create());
            this.fetchStudyComment(client, studyId).then(set => {
                if (set) {
                    dispatch(ReceiveFixedCommentsAction.create(set.fixedCommentSets.find(fcs => fcs.entityType === FixedCommentEntityTypeEnum.Session).comments.filter(x => !x.disabled)));
                }
            });
        };
    }

    static async fetchStudyComment(client: WebPortalApiClient, studyId: string): Promise<StudyFixedCommentSet> {
        const comments = client.client.getStudyFixedCommentSets(undefined, `studyId eq ${studyId} and sessionType eq 'ST_COUGH' and commentSetType eq 'OVERREAD'`, undefined, 'fixedcommentsets($expand=comments)');

        return (await comments).value[0];
    }

    static async fetchCommentSet(legacyClient: WebPortalLegacyClientInternal, setId: string): Promise<OverreadFixedCommentSet> {
        return await legacyClient.getFixedCommentSet(setId);
    }

    static async fetchComments(legacyClient: WebPortalLegacyClientInternal, commentIds: string[]): Promise<Array<OverreadFixedComment>> {
        const comments = await legacyClient.getFixedComments({
            Filters: [
                {
                    Member: "Id",
                    Values: commentIds
                }
            ]
        });

        return comments.Data;
    }
}

export class SavePlaybackPositionAction implements Redux.Action {
    static create(): SavePlaybackPositionAction {
        return {
            type: ActionType.SavePlaybackPosition
        };
    }
    type: ActionType.SavePlaybackPosition;
}

export class ResumePlaybackAsyncAction {
    static create(coughMarshalClient: CoughMarshalClient, webPortalClient: WebPortalApiClient,) {
        return async (dispatch: Dispatch<AnalyseState>, getState: () => AnalyseState) => {
            const state = getState();
            const segment = Math.floor(state.core.storedPlaybackTime / (24 * 60 * 60) + 1);
            if (segment > 1) {
                await dispatch(ChangeSelectedSegmentAsyncAction.create(segment, coughMarshalClient, webPortalClient, state.core.sessionMetadata.sessionId, state.core.coughAnalysisSet.id));
            }

            dispatch(ResumePlaybackJumpAction.create());
            dispatch(ResumePlaybackJumpCompleteAction.create());
        }
    }
}

export class ResumePlaybackJumpCompleteAction implements Redux.Action {
    static create(): ResumePlaybackJumpCompleteAction {
        return {
            type: ActionType.ResumePlaybackJumpComplete
        };
    }
    type: ActionType.ResumePlaybackJumpComplete;
}

export class ResumePlaybackJumpAction implements Redux.Action {
    static create(): ResumePlaybackJumpAction {
        return {
            type: ActionType.ResumePlaybackJump
        };
    }
    type: ActionType.ResumePlaybackJump;
}

export class AcceptabilitySetAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal, client: WebPortalClient, location, navigate, analysisSetId: string, status: OverreadStatusEnum, auditAnnotation?: string) {
        return async (dispatch: Dispatch<AnalyseState>, getState: () => AnalyseState) => {
            const analysisSetState = getState().analysisSet.coughAnalysisSets.filter(c => c.Id == analysisSetId && c.IsSelected == true);
            const analysisSetFixedComments = await legacyClient.getAnalysisSetFixedComments([{ Member: "Id", Values: [analysisSetId] }])

            const stateFixedCommentValues = analysisSetState.flatMap(item => item.FixedCommentIds);
            const fixedCommentsValues = analysisSetFixedComments.Data.flatMap(item => item.FixedCommentIds);

            if (stateFixedCommentValues.length == 0) {
                for (const value of fixedCommentsValues)
                    await legacyClient.toggleFixedComment(analysisSetId, value, false);
            } else {

                for (const value of stateFixedCommentValues) {
                    if (!fixedCommentsValues.includes(value))
                        await legacyClient.toggleFixedComment(analysisSetId, value, true);
                }

                for (const value of fixedCommentsValues) {
                    if (!stateFixedCommentValues.includes(value))
                        await legacyClient.toggleFixedComment(analysisSetId, value, false);
                }
            }
            //Marking the state as submitting to disable the buttons.
            //This prevents a double click event from happening causing 2 analysis sets to be created.
            dispatch(AcceptabilitySetIsSubmittingAction.create());
            return legacyClient.updateCoughAcceptability(analysisSetId, status, getState().core.selectedWaveform, auditAnnotation)
                .then(async json => {

                    if (status !== OverreadStatusEnum.Pending) {
                        const state = getState();
                        const confirmedDuplicates: PeaksPoint[] = state.core.peaksJs.points.getPoints().filter((x: PeaksPoint) => x.confirmedValidDuplicate);

                        if (confirmedDuplicates.length > 0) {
                            await client.postAuditTrailEvent({
                                summary: `${confirmedDuplicates.length} confirmed duplicates for analysis set '${analysisSetId}', timepoints ${confirmedDuplicates.map(d => state.core.rawTimestampPoints.get(d.id)).sort((a, b) => a - b).join(", ")}`,
                                auditAction: AuditTrailActionEnum.ConfirmedValidDuplicates
                            });
                        }
                    }

                    
                    location.pathname = location.pathname.replace('false', 'true');
                    navigate(location, { replace: true });
                    navigate("/cough/analysis")

                })
                .catch(error => dispatch(LoadErrorAction.create()));
        };
    }
}

export class RemoveCommentAction implements Redux.Action {
    static create(client: WebPortalApiClient, id?: string): RemoveCommentAction {
        return {
            type: ActionType.RemoveComment,
            client,
            id,
        };
    }
    type: ActionType.RemoveComment;
    client: WebPortalApiClient
    id?: string; // Optional, otherwise active will be removed,

}

export class RequestCurrentAnalysisSetAction implements Redux.Action {
    static create(analysisSet: CoughAnalysisSet): RequestCurrentAnalysisSetAction {
        return {
            type: ActionType.RequestCurrentAnalysisSet,
            analysisSet: analysisSet
        };
    }
    type: ActionType.RequestCurrentAnalysisSet;
    analysisSet: CoughAnalysisSet;
}

export class RequestVisualReviewForAnalysisSetAction implements Redux.Action {
    static create(visualReview: boolean): RequestVisualReviewForAnalysisSetAction {
        return {
            type: ActionType.RequestVisualReviewForAnalysisSet,
            visualReview: visualReview
        };
    }
    type: ActionType.RequestVisualReviewForAnalysisSet;
    visualReview: boolean;
}

export class RequestBlindCommentsAction implements Redux.Action {
    static create(blindComments: boolean): RequestBlindCommentsAction {
        return {
            type: ActionType.RequestBlindComments,
            blindComments: blindComments
        };
    }
    type: ActionType.RequestBlindComments;
    blindComments: boolean;
}

export class RequestAnalysisSetCommentAction implements Redux.Action {
    static create(comments: CoughAnalysisSetComment[]): RequestAnalysisSetCommentAction {
        return {
            type: ActionType.RequestAnalysisSetComments,
            comments: comments
        };
    }
    type: ActionType.RequestAnalysisSetComments;
    comments: CoughAnalysisSetComment[];
}

export class UpdateAnalysisSetEventLocallyAction {
    static create(event) {
        return {
            type: ActionType.UpdateAnalysisSetEventLocally,
            payload: event
        };
    }
    type: ActionType.UpdateAnalysisSetEventLocally;
    payload: any;
}

export class InitializeAnalysisSetCommentAsyncAction {
    static create(client: WebPortalApiClient, analysisSetId: string, selectedSegment: number) {
        return async dispatch => {
            const segmentHoursValue = selectedSegment * 24;
            const segmentSecsStartTime = (segmentHoursValue - 24) * 60 * 60;
            const segmentSecsEndTime = (segmentHoursValue) * 60 * 60;

            const comments = analysisSetId ? (await client.client.getCoughAnalysisSetComments(undefined, `analysisSetId eq ${analysisSetId} and commentStartTime ge ${segmentSecsStartTime} and commentStartTime lt ${segmentSecsEndTime} or (analysisSetId eq ${analysisSetId} and commentStartTime eq null and commentEndTime eq null)`)).value : [];

            dispatch(RequestAnalysisSetCommentAction.create(comments));
        }
    }

}

export class AddAnalysisSetCommentAsyncAction {
    static create(client: WebPortalApiClient, analysisSetId: string, commentStartTime: number, commentEndTime: number, comment: string, replyToComment: string, selectedSegment: number) {
        return async dispatch => {
            const segmentHoursValue = selectedSegment * 24;
            const segmentSecsStartTime = (segmentHoursValue - 24) * 60 * 60;
            const segmentSecsEndTime = (segmentHoursValue) * 60 * 60;

            dispatch(SetVisualInspectionErrorAction.create(null));

            try {
                const _ = await client.client.postCoughAnalysisSetComment({ analysisSetId: analysisSetId, commentStartTime: commentStartTime, commentEndTime: commentEndTime, comment: comment, parentCommentId: replyToComment, segmentOffset: segmentSecsStartTime });
            } catch (ex) {
                dispatch(SetVisualInspectionErrorAction.create(ex.message));
            }
            const comments = await client.client.getCoughAnalysisSetComments(undefined, `analysisSetId eq ${analysisSetId} and commentStartTime ge ${segmentSecsStartTime} and commentStartTime lt ${segmentSecsEndTime} or (analysisSetId eq ${analysisSetId} and commentStartTime eq null and commentEndTime eq null)`);

            dispatch(RequestAnalysisSetCommentAction.create(comments.value));
        }
    }

}

export class AddAnalysisSetEventDisputedCommentAsyncAction {
    static create(client: WebPortalApiClient, analysisSetEventId: string, comment: string, disputedAccepted: boolean, legacyClient: WebPortalLegacyClientInternal, coughAnalysisSetId: string, selectedWaveform: string, peaksJs: PeaksJs) {
        return async dispatch => {
                try {
                    const updated = await client.client.patchCoughAnalysisSetEvent(
                        { disputedComment: comment, disputedAccepted },
                        analysisSetEventId
                    );

                    dispatch(UpdateAnalysisSetEventLocallyAction.create(updated));
                    dispatch(SetPointUpdatedAction.create(peaksJs.waveform.points.getPoints({ id: updated.id })[0]));
                    return updated;

                } catch (ex) {
                    console.error(ex);
                    throw ex;
                }
        }
    }

}

export class RemoveAnalysisSetCommentAsyncAction {
    static create(client: WebPortalApiClient, commentId: string, analysisSetId: string, selectedSegment: number) {
        return async dispatch => {
            await client.client.deleteCoughAnalysisSetComment(commentId);
            const segmentHoursValue = selectedSegment * 24;
            const segmentSecsStartTime = (segmentHoursValue - 24) * 60 * 60;
            const segmentSecsEndTime = (segmentHoursValue) * 60 * 60;
            const comments = await client.client.getCoughAnalysisSetComments(undefined, `analysisSetId eq ${analysisSetId} and commentStartTime ge ${segmentSecsStartTime} and commentStartTime lt ${segmentSecsEndTime} or (analysisSetId eq ${analysisSetId} and commentStartTime eq null and commentEndTime eq null)`);

            dispatch(RequestAnalysisSetCommentAction.create(comments.value));
        }
    }
}

export class InitializeCurrentAnalysisSetAsyncAction {
    static create(client: WebPortalApiClient, analysisSetId: string) {
        return async dispatch => {
            const analysisSet = await client.client.getCoughAnalysisSet(analysisSetId);
            dispatch(RequestCurrentAnalysisSetAction.create(analysisSet));
        }
    }
}

export class InitializeVisualReviewForAnalysisSetAction {
    static create(client: WebPortalApiClient, legacyClient: WebPortalLegacyClientInternal, analysisSetId: string) {
        return async dispatch => {
            const analysisSet = await client.client.getCoughAnalysisSet(analysisSetId);
            const session = await client.client.getSession(analysisSet?.sessionId);
            const sessionitem = await client.client.getStudyScheduleSession(session.sessionScheduleItemId);
            const coughAnalysisSet = await legacyClient.getCoughAnalysisSet(analysisSetId);
            const studySettings = await legacyClient.getStudyCoughSettings(coughAnalysisSet.Study.Id);

            const isVisualReviewMandatory = (analysisSet, studySettings) => {
                const typeToSettingMap = {
                    [CoughAnalysisSetTypeEnum.QualityCheck]: studySettings.VisualReviewMandatorySetting.VisualReviewMandatoryQc,
                    [CoughAnalysisSetTypeEnum.ProjectQualityAssurance]: studySettings.VisualReviewMandatorySetting.VisualReviewMandatoryProjectQa,
                    [CoughAnalysisSetTypeEnum.MonitoringQualityAssurance]: studySettings.VisualReviewMandatorySetting.VisualReviewMandatoryMonitoringQa,
                    [CoughAnalysisSetTypeEnum.DifficultCougherQualityAssurance]: studySettings.VisualReviewMandatorySetting.VisualReviewMandatoryDifficultCougherQa,
                    [CoughAnalysisSetTypeEnum.WeeklyQualityAssurance]: studySettings.VisualReviewMandatorySetting.VisualReviewMandatoryWeeklyQa,
                }
                if (typeToSettingMap[analysisSet.type] === true) {
                    return typeToSettingMap[analysisSet.type];
                }

                return false;
            }

            if (analysisSet.type == CoughAnalysisSetTypeEnum.Analysis) {
                if (sessionitem?.visualReview) {
                    dispatch(RequestVisualReviewForAnalysisSetAction.create(sessionitem.visualReview));
                }
            } else if (isVisualReviewMandatory(analysisSet, studySettings)) {
                dispatch(RequestVisualReviewForAnalysisSetAction.create(isVisualReviewMandatory(analysisSet, studySettings)));
            }
            else {
                dispatch(RequestVisualReviewForAnalysisSetAction.create(false));
            }
        }
    }
}

export class InitializeCommentBlindingAsyncAction {
    static create(client: WebPortalApiClient, userEmail: string, analysisSetId: string, currentUserPermissions: Permission[]) {
        return async dispatch => {
            const analysisSet = await client.client.getCoughAnalysisSet(analysisSetId);
            let blindComments = undefined;
            if (!currentUserPermissions.some(x => x.Id == PermissionEnum.ViewAllCoughAnalysisSetComments) && analysisSet.primary === true) {

                const encodedEmail = encodeURIComponent(userEmail);
                const analysisSets = await client.client.getCoughAnalysisSets(undefined, `sessionId eq ${analysisSet.sessionId} and analyst eq '${encodedEmail}'`);

                blindComments = analysisSets.value.some(item =>
                    (item.type === 'CAS_PROJECT_QA' || item.type === 'CAS_WEEKLY_QA' || item.type === 'CAS_MONITORING_QA' || item.type === 'CAS_DIFFICULT_COUGHER_QA') && item.status === 'ORS_PENDING'
                );

            }
            dispatch(RequestBlindCommentsAction.create(blindComments));
        }
    }
}

export class AcceptabilitySetIsSubmittingAction implements Redux.Action {
    type: ActionType.AcceptabilitySetIsSubmitting;
    submitting: boolean;

    static create(submitting = true): AcceptabilitySetIsSubmittingAction {
        return {
            type: ActionType.AcceptabilitySetIsSubmitting,
            submitting: submitting,
        };
    }
}

export class ToggleSessionNotesVisibilityAction implements Redux.Action {
    static create(): ToggleSessionNotesVisibilityAction {
        return {
            type: ActionType.ToggleSessionNotesVisibility
        };
    }
    type: ActionType.ToggleSessionNotesVisibility;
}

export class AddNewNoteAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal, annotation: string) {
        return async (dispatch, getState: () => AnalyseState) => {
            const state = getState();
            dispatch(AddingNewNoteAction.create());
            await legacyClient.putSessionNotes(state.core.sessionMetadata.sessionId, annotation);
            dispatch(InitializeNotesAsyncAction.create(legacyClient));
            dispatch(AddNewNoteDoneAction.create());
        };
    }
}

export class EditNoteAsyncAction {
    static create(legacyClient: WebPortalLegacyClientInternal, client: WebPortalClient, id: string, comment: string, annotation: string) {
        return async (dispatch) => {
            dispatch(AddingNewNoteAction.create());
            await client.patchSessionNote(
                {
                    comment: comment,
                }, id, annotation);
            dispatch(InitializeNotesAsyncAction.create(legacyClient));
            dispatch(AddNewNoteDoneAction.create());
        };
    }
}

export class AddingNewNoteAction implements Redux.Action {
    static create(): AddingNewNoteAction {
        return {
            type: ActionType.AddingNewNote
        };
    }
    type: ActionType.AddingNewNote;
}

export class AddNewNoteDoneAction implements Redux.Action {
    static create(): AddNewNoteDoneAction {
        return {
            type: ActionType.AddNewNoteDone
        };
    }
    type: ActionType.AddNewNoteDone;
}

export class JumpToTimePointAction implements Redux.Action {
    static create(timepoint: number): JumpToTimePointAction {
        return {
            type: ActionType.JumpToTimepoint,
            timepoint
        };
    }
    type: ActionType.JumpToTimepoint;
    timepoint: number;
}

export class ShowMaximumAnalysisSetsAlertAction implements Redux.Action {
    static create(): ShowMaximumAnalysisSetsAlertAction {
        return {
            type: ActionType.ShowMaximumAnalysisSetsAlert
        };
    }
    type: ActionType.ShowMaximumAnalysisSetsAlert;
}

export class HideMaximumAnalysisSetsAlertAction implements Redux.Action {
    static create(): HideMaximumAnalysisSetsAlertAction {
        return {
            type: ActionType.HideMaximumAnalysisSetsAlert
        };
    }
    type: ActionType.HideMaximumAnalysisSetsAlert;
}

export class PlayheadMappedAction implements Redux.Action {
    static create(): PlayheadMappedAction {
        return {
            type: ActionType.PlayheadMapped
        };
    }

    type: ActionType.PlayheadMapped;
}


export class OpenHourSegmentsModalAction implements Redux.Action {
    static create(): OpenHourSegmentsModalAction {
        return {
            type: ActionType.OpenHourSegmentsModal
        };
    }

    type: ActionType.OpenHourSegmentsModal;
}

export class CloseHourSegmentsModalAction implements Redux.Action {
    static create(): CloseHourSegmentsModalAction {
        return {
            type: ActionType.CloseHourSegmentsModal
        };
    }

    type: ActionType.CloseHourSegmentsModal;
}

export class RequestHourSegmentsAction {
    static create(): RequestHourSegmentsAction {
        return {
            type: ActionType.RequestHourSegments
        };
    }

    type: ActionType.RequestHourSegments;
}

export class GetHourSegmentsAsyncAction {
    static create = (segmentOffsetInHours: number) => (dispatch: Dispatch<AnalyseState>, getState: () => AnalyseState) => {
        dispatch(RequestHourSegmentsAction.create());

        const state = getState();

        try {
            let hourSegmentMap = state.core.hourSegmentsMap;
            const hourSegments = GetHourSegments(state.core.positions, WaveformType[state.core.selectedWaveform], segmentOffsetInHours, state.core.selectedSegment);
            hourSegmentMap = new Map<string, HourBasedSegmentViewModel[]>([]).set(
                state.core.selectedWaveform,
                hourSegments.map(hs => new HourBasedSegmentViewModel(hs))
            );

            dispatch(LoadHourSegmentsAction.create(hourSegmentMap));
        } catch {
            dispatch(HourlySegmentsLoadErrorAction.create());
        }

    };
}

export class LoadHourSegmentsAction implements Redux.Action {
    static create(
        hourSegmentsMap: Map<string, HourBasedSegmentViewModel[]>
    ): LoadHourSegmentsAction {
        return {
            type: ActionType.LoadHourSegments,
            hourSegmentsMap
        };
    }

    type: ActionType.LoadHourSegments;
    hourSegmentsMap: Map<string, HourBasedSegmentViewModel[]>;
}

export class ShowAcceptabilityAuditModalAction implements Redux.Action {
    type: ActionType.ShowAcceptabilityAuditModal;
    acceptability: OverreadStatusEnum;

    static create(acceptability: OverreadStatusEnum): ShowAcceptabilityAuditModalAction {
        return {
            type: ActionType.ShowAcceptabilityAuditModal,
            acceptability: acceptability
        };
    }
}

export class CloseAcceptabilityAuditModalAction implements Redux.Action {
    type: ActionType.CloseAcceptabilityAuditModal;

    static create(): CloseAcceptabilityAuditModalAction {
        return {
            type: ActionType.CloseAcceptabilityAuditModal
        };
    }
}

export class PopulateRawTimepointsAction implements Redux.Action {
    type: ActionType.PopulateRawTimepoints;
    rawTimestampPoints: Map<string, number>;

    static create(rawTimestampPoints: Map<string, number>) {
        return {
            type: ActionType.PopulateRawTimepoints,
            rawTimestampPoints: rawTimestampPoints,
        };
    }
}

export class PlaybackServiceStatusAction implements Redux.Action {
    type: ActionType.PlaybackServiceStatusAction;
    status: string;

    static create(status: string) {
        return {
            type: ActionType.PlaybackServiceStatusAction,
            status: status,
        }
    }
}

export class EventTypesNotConfiguredAction implements Redux.Action {
    static create(): EventTypesNotConfiguredAction {
        return {
            type: ActionType.EventTypesNotConfigured,
        };
    }
    type: ActionType.EventTypesNotConfigured;
}

export class SetEventDuplicateThresholdAction implements Redux.Action {
    static create(threshold: number): SetEventDuplicateThresholdAction {
        return {
            type: ActionType.SetEventDuplicateThreshold,
            threshold: threshold
        };
    }

    type: ActionType.SetEventDuplicateThreshold;
    threshold: number;
}

export class SetAcceptanceErrorAction implements Redux.Action {
    static create(message: string): SetAcceptanceErrorAction {
        return {
            type: ActionType.SetAcceptanceError,
            message: message
        };
    }

    type: ActionType.SetAcceptanceError;
    message: string;
}

export class SetDisputedAcceptanceErrorAction implements Redux.Action {
    static create(message: string): SetDisputedAcceptanceErrorAction {
        return {
            type: ActionType.SetDisputedAcceptanceError,
            message: message
        };
    }

    type: ActionType.SetDisputedAcceptanceError;
    message: string;
}

export class SetDuplicateVerifiedAction implements Redux.Action {
    static create(id: string): SetDuplicateVerifiedAction {
        return {
            type: ActionType.SetDuplicateVerified,
            id: id
        };
    }

    type: ActionType.SetDuplicateVerified;
    id: string;
}
export class SetPointUpdatedAction implements Redux.Action {
    static create(event: PeaksPoint): SetPointUpdatedAction {
        return {
            type: ActionType.SetPointUpdated,
            event
        };
    }

    type: ActionType.SetPointUpdated;
    event: PeaksPoint;
}

export class LoadedAction implements Redux.Action {
    static create(): LoadedAction {
        return {
            type: ActionType.Loaded,
        };
    }
    type: ActionType.Loaded;
}

export class SetVisualInspectionErrorAction implements Redux.Action {
    static create(message: string): SetVisualInspectionErrorAction {
        return {
            type: ActionType.SetVisualInspectionErrorAction,
            message: message
        };
    }

    type: ActionType.SetVisualInspectionErrorAction;
    message: string;
}

export class SetAudioLengthAction implements Redux.Action {
    static create(length: number): SetAudioLengthAction {
        return {
            type: ActionType.SetAudioLength,
            length: length
        };
    }
    type: ActionType.SetAudioLength;
    length: number;
}

export class ToggleQCStatementsAction implements Redux.Action {
    static create(isOpen: boolean): ToggleQCStatementsAction {
        return {
            type: ActionType.ToggleQCStatements,
            isOpen: isOpen,
        };
    }

    type: ActionType.ToggleQCStatements;
    isOpen: boolean;
}
